import React, {useState} from 'react';

import Box from '@mui/material/Box';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import ToggleButton from '@mui/material/ToggleButton'
import { PieChart  } from '@mui/x-charts/PieChart';
import { calculateSequencingStats } from './utils/sequencingStats';

function SequencingYieldPieChart(props) {
    const {
        analysisAttributes,
        showHumanYield
    } = props;

    const [view, setView] = useState('megabases')

    const analysis = {
        attributes: analysisAttributes
    }

      const isIllumina = analysis.attributes.raw_total_megabases_r2 !== null
      const {
          qcFilteredMegabases,
          qcFilteredReads,
          humanReadsRemovedMegabases,
          humanReadsRemovedReads,
        } = calculateSequencingStats(analysis, isIllumina);

    const analyzed = view === 'megabases' ? 
        (isIllumina ? (analysisAttributes.human_reads_removed_megabases + analysisAttributes.human_reads_removed_megabases_r2) : analysisAttributes.human_reads_removed_megabases) : 
        analysisAttributes.human_reads_removed_reads

    const lowQuality = view === 'megabases' ? 
        qcFilteredMegabases :
        qcFilteredReads

    const human = view === 'megabases' ?
        humanReadsRemovedMegabases :
        humanReadsRemovedReads

    const data = [
        { id: 0, value: analyzed, label: 'Analyzed Data', color: 'green' },
        { id: 2, value: lowQuality, label: 'Low Quality', color: '#FF5326' },
    ]

    if (showHumanYield) {
        data.push({ id: 1, value: human, label: 'Human', color: '#5267AA' })
    }

    return (
      <Box sx={{textAlign: "right"}}>
          <ToggleButtonGroup sx={{marginTop: "20px"}} size="small" value={view} exclusive onChange={(event, newView) => setView(newView)} aria-label="megabases reads toggle">
              <ToggleButton value="megabases" aria-label="megabases">
                Bases
              </ToggleButton>
              <ToggleButton value="reads" aria-label="reads">
                Reads
              </ToggleButton>
          </ToggleButtonGroup>
          <PieChart sx={{cursor: 'pointer', overflow: 'visible'}} height={200} series={[
              {
                  valueFormatter: (item) => `${item.value.toLocaleString()} ${view === 'megabases' ? 'MBs' : `read${isIllumina ? ' pairs' : 's'}`}`,
                  data: data,
                  highlightScope: { fade: 'global', highlight: 'item' },
                  faded: {innerRadius: 30, additionalRadius: -30, color: 'gray'}
              }
          ]} />
      </Box>
    )
}

export default SequencingYieldPieChart;
